import services from "../services";
import { UserDto } from "../types/user.dto";
import { RefreshTokenTime } from "../types/auth.dto"

interface JsonDecode {
  user?: UserDto,
  exp?: Date
}

export const jwtDecode  = (token: string): JsonDecode => {
    try {
      if(token) {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
        );
        const user = JSON.parse(jsonPayload).user;
        const timeStamp = JSON.parse(jsonPayload).exp;
        return { user, exp: timeStamp};
      }
    } catch (error) {
      console.error('Error decoding JWT:', error);
      return {};
    }
    return {};
};

export const checkTokenExpiration = (): boolean => {
  const token = services.auth.getToken();
  if(!!token) {
    const decoded: any = jwtDecode(token);
    const expirationTime = decoded.exp * 1000;
    const currentTime = Date.now();
    if (currentTime >= expirationTime - RefreshTokenTime.REFRESH_BEFORE * 60 * 1000) {
      return true;
    }
  }
  return false
}

export const tokenExpirationTimePart = (): number => {
  const token = services.auth.getToken();
  if(token) {
    const decoded: any = jwtDecode(token);
    return (decoded.exp) / RefreshTokenTime.REFRESH_BETWEEN;
  }
  return 0;
}